<template>
  <section class="f-52">
    <div class="alive-3-content">
      <div class="video-container" v-ia>
        <div class="border_container_night video_size f-select-center">
          <m-video
            ref="video"
            muted
            playsinline
            webkit-playsinline
            disablepictureinpicture
            poster="@/v2/auto/assets/image/52/map.png"
            src="@/v2/auto/assets/video/52/0.mp4"
          />
        </div>
        <Replay @click="onReplay" />
      </div>
      <div class="title f-center-title">让你眼前一亮的全新设计</div>
      <div class="des f-center-sub-title">
        不同于市面上的 AI 对话对导航的遮挡与干扰
      </div>
      <div class="des f-center-sub-title">小窗出现时导航将自动避让</div>
    </div>
  </section>
</template>

<script>
import Replay from '@/components/replay.vue'
import { videoPlayByVisibleArea, replayVideo } from '@/utils'
export default {
  components: {
    Replay,
  },
  name: 'BeautyAlive',
  data() {
    return {
      preload_: true,
    }
  },
  mounted() {
    const { video } = this.$refs
    video && videoPlayByVisibleArea(video)
  },
  methods: {
    onReplay: function () {
      replayVideo(this.$refs.video)
    },
  },
}
</script>

<style lang="less" scoped>
.f-52 {
  position: relative;
  overflow: hidden;
  margin-top: -5px;

  .alive-3-content {
    position: relative;
    background: #000000;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    .video-container {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      margin-bottom: 20px;
      color: white;
      .video_size {
        margin-bottom: 20px;
      }
      video {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  .title {
    font-weight: bold;
    background: radial-gradient(
      131.96% 70.14% at 50% 18.06%,
      #eadaff 0%,
      #ffffff 100%
    );
    color: transparent;
    background-clip: text;
    margin-bottom: 20px;
  }
  .des {
    text-align: center;
    line-height: 1.5;
    color: #ffffff80;
  }
}
</style>
